// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/c-of-a-invalidation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/c-of-a-invalidation/c-of-a-invalidation.js';
import g1 from '../lessons/air-law/c-of-a-invalidation/external-load-approval.js';

mount([g0, g1]);
